export const auctionDetailLink = "https://www.kasikornbank.com/th/propertyforsale/promotion/pages/npa-auction-2024.aspx#howto";